$(document).on('click', ".touch-menu", function() {
  if($(this).hasClass('on')){
    $('body').removeClass('compensate-for-scrollbar');
    $(this).removeClass('on');
    $(".menu-top__mob").removeClass('opened');
  }else{
    $('body').addClass('compensate-for-scrollbar');
    $(this).addClass('on');
    $(".menu-top__mob").addClass('opened');
  }

  return false;
});

$(window).on('scroll resize load', function(){
  if(ww>=1200) return;
  var top = document.getElementById('main_menu_line').getBoundingClientRect().bottom;
  $(".menu-top__mob").css('top', top+'px');
});